import { render, staticRenderFns } from "./allTurnover.vue?vue&type=template&id=0e97a990"
import script from "./allTurnover.vue?vue&type=script&lang=ts"
export * from "./allTurnover.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports